<template>
  <div>
    <b-form-group label="Title">
      <b-input v-model="content.title" placeholder="e.g Awesome Text" />
    </b-form-group>

    <b-form-group label="Content">
      <wysiwyg-editor id="edit" tag="textarea" :config="config" v-model="content.content" />
      <b-modal title="Pick image">
        <image-browser />
      </b-modal>
    </b-form-group>
  </div>
</template>

<script>
import WysiwygEditor from '@/components/WysiwygEditor';
import ImageBrowser from '../../../components/ImageBrowser'

export default {
  name: 'PagesTextWidget',
  components: { ImageBrowser, WysiwygEditor },
  props: { value: { type: Object } },
  data() {
    return {
      content: this.value,
      config: {
        toolbarButtons: [
          'insertImage',
          'insertLink',
          '|',
          'fontSize',
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'clearFormatting',
          'insertTable',
          '|',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          '|',
          'undo',
          'redo',
        ],
        fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '36', '48', '60', '72', '96']
      },
    }
  },
}
</script>
